import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE05001S = () => {
    
  return (
	<CommonLayout>
      <CommonMenu />
		<>
            <div id="contents" className="container">
                <div className="sub-title bg-type05">
                    <h2>개인정보처리방침</h2>
                </div>

                <div id="cont" className="cont">
                    <div className="inner">

                        {/* 탭 메뉴 */}
                        <div className="tabs ty02">
                            <ul className="tab-item col03">
                                <li>
                                    <Link to="/GNBPURE05001S">개인정보처리방침</Link>
                                </li>
                                <li className="on">
                                    <Link to="/GNBPURE05002S">이용약관</Link>
                                </li>
                                <li>
                                    <Link to="/GNBPURE05003S">이메일 무단수집공고</Link>
                                </li>
                            </ul>
                        </div>

                        {/* 이용약관 */}
                            <div className="notice active">

                                <h1 className="contTitle">이용약관</h1>

                                <div className="cont-wrap">
                                    <div id="sub_contents" className="container-fluid no-padding">
                                        <div className="container sub_contents_area">
                                            <div className="privacy clearfix">
                                                <div className="row">

                                                    <h2>제 1장 이용약관 총칙</h2>

                                                    <p className="contsubTitle">제 1조(목적)</p>
                                                    <p>
                                                        본 약관은 GnB소프텍(이하 "회사")에서 제공하는 모든 서비스(이하 '서비스')의 이용조건 및 절차, 
                                                        이용자와 회사의 권리, 의무 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 2조(약관의 효력과 변경)</p>
                                                    <p>
                                                        1. 귀하가 본 약관 내용에 동의하는 경우, 회사의 서비스 제공 행위 및 귀하의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다. <br />
                                                        2. 회사는 본 약관을 사전 고지 없이 변경할 수 있고, 변경된 약관은 회사 내에 공지하거나 이메일을 통해 회원에게 공지하며, 
                                                        공지와 동시에 그 효력이 발생됩니다. 이용자가 변경된 약관에 동의하지 않는 경우, 이용자는 본인의 회원등록을 
                                                        취소(회원탈퇴)할 수 있으며 계속 사용의 경우는 약관 변경에 대한 동의로 간주됩니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 3조(약관외 준칙)</p>
                                                    <p>
                                                        본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 정보통신윤리위원회 심의 규정, 
                                                        정보통신 윤리강령, 프로그램보호법 및 기타 관련 법령의 규정에 의합니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 4조(용어의 정의)</p>
                                                    <p>
                                                        본 약관에서 사용하는 용어의 정의는 다음과 같습니다. 
                                                        <br />
                                                        - 이용자 : 본 약관에 따라 회사가 제공하는 서비스를 받는 자. 
                                                        <br />
                                                        - 가입 : 회사가 제공하는 신청서 양식에 해당 정보를 기입하고, 본 약관에 동의하여 서비스 이용계약을 완료시키는 행위. 
                                                        <br />
                                                        - 회원 : 회사에 개인 정보를 제공하여 회원 등록을 한 자로서 회사가 제공하는 서비스를 이용할 수 있는 자. 
                                                        <br />
                                                        - 비밀번호 : 이용자와 회원ID가 일치하는지를 확인하고 통신상의 자신의 비밀보호를 위하여 이용자 자신이 선정한 문자와 숫자의 조합. 
                                                        <br />
                                                        - 탈퇴 : 회원이 이용계약을 종료시키는 행위.
                                                    </p>
                                    
                                                    <h2>제 2장 서비스 제공 및 이용</h2>
                                                    <p className="contsubTitle">제 5조 (이용계약의 성립)</p>
                                                    <p>
                                                        1. 이용계약은 신청자가 온라인으로 회사에서 제공하는 소정의 가입신청 양식에서 요구하는 사항을 기록하여 가입을 완료하는 것으로 성립됩니다. 
                                                        <br />
                                                        2. 회사는 다음 각 호에 해당하는 이용계약에 대하여는 가입을 취소할 수 있습니다. 
                                                        <br />
                                                        ⓵ 다른 사람의 명의를 사용하여 신청하였을 때 
                                                        <br />
                                                        ⓶ 회원가입 신청서의 내용을 허위로 기재하였거나 신청하였을 때 
                                                        <br />
                                                        ⓷ 회사 서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을 때 
                                                        <br />
                                                        ⓸ 회사를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우 
                                                        <br />
                                                        ⓹ 기타 회사가 정한 이용신청요건이 미비 되었을 때
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 6조 (회원정보 사용에 대한 동의)</p>
                                                    <p>
                                                        1. 회원의 개인정보는 공공기관의 개인정보보호법에 의해 보호됩니다. 
                                                        <br />
                                                        2. 회사의 회원정보는 다음과 같이 사용, 관리, 보호됩니다. 
                                                        <br />
                                                        ⓵ 개인정보의 사용 : 회사는 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙 없이 
                                                        제3자에게 누설, 배포하지 않습니다. 단, 법률의 규정에 의해 국가기관의 요구가 있는 경우는 예외로 합니다. 
                                                        <br />
                                                        ⓶ 개인정보관리 : 회원은 서비스의 개인정보관리에서 수시로 본인의 개인정보를 수정/삭제할 수 있습니다. 
                                                        <br />
                                                        ⓷ 개인정보의 보호 : 귀하의 개인정보는 본인만이 열람/수정/삭제할 수 있으며, 
                                                        이는 ID와 비밀번호를 통해 관리됩니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 7조(사용자의 정보 보안)</p>
                                                    <p>
                                                        1. 가입 신청자가 회사 서비스 가입 절차를 완료하는 순간부터 귀하는 입력한 정보의 비밀을 유지할 책임이 있으며, 
                                                        회원의 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 8조(서비스의 중지)</p>
                                                    <p>
                                                        회사는 이용자가 본 약관의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 제한 및 중지할 수 있습니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 10조(게시물의 저작권)</p>
                                                    <p>
                                                        1. 귀하가 게시한 게시물의 내용에 대한 권리는 귀하에게 있습니다. 
                                                        <br />
                                                        2. 회사는 게시된 내용을 사전 통지 없이 편집, 이동할 수 있는 권리를 보유하며, 
                                                        게시판 운영 원칙에 따라 사전 통지 없이 삭제할 수 있습니다. 
                                                        <br />
                                                        3. 귀하의 게시물이 타인의 저작권을 침해함으로써 발생하는 민, 형사상의 책임은 
                                                        전적으로 귀하가 부담하여야 합니다.
                                                    </p>
                                    
                                                    <h2>제 3장 책임과 의무</h2>
                                                    <p className="contsubTitle">제 11조 (회사의 의무)</p>
                                                    <p>
                                                        회사는 회원의 개인 신상 정보를 본인의 승낙 없이 타인에게 누설, 배포하지 않습니다. 
                                                        다만, 법률에 의해 국가기관 등의 요구가 있는 경우는 예외로 합니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">제 15조(면책조항)</p>
                                                    <p>
                                                        1. 회사는 회원이나 제3자에 의해 표출된 의견을 승인하거나 반대하거나 수정하지 않습니다. 
                                                        회사는 어떠한 경우라도 회원이 서비스에 담긴 정보에 의존해 얻은 이득이나 입은 손해에 대해 책임이 없습니다.
                                                    </p>
                                    
                                                    <h4>부칙</h4>
                                                    <p>시행일 약관은 2017년 10월 18일부터 시행됩니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>       
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE05001S;
